import React from 'react';
import styled from 'styled-components';
import Link from 'components/_utility/Link/Link';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  background-color: #eee;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
`;

export const TextPlaceholder = styled.div`
  width: ${({ width = 0, fluid }) => (fluid ? '100%' : `${width}px`)};
  height: ${({ height = 5 }) => height}px;
  background-color: #e0e0e0;
  display: ${({ fluid }) => (fluid ? 'block' : 'inline-block')};
  margin-bottom: ${({ marginBottom = 0 }) => marginBottom}px;
`;

export const ImageWrap = styled.div`
  border-bottom: 1px solid #e0e0e0;
  height: 150px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  display: block;
  max-height: 110px;
`;

export const Content = styled.div`
  padding: 35px;
  height: ${({ isListingsPage }) => (isListingsPage ? '115px' : '250px')};

  @media ${minBp('tabletLarge')} {
    height: 250px;
  }
`;

export const Name = styled.h4`
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 10px;
`;

export const Price = styled.div`
  text-align: center;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  color: black;
  margin-bottom: 5px;
`;

export const Finance = styled.div`
  margin-bottom: 12px;
  font-size: 14px;
  text-align: center;
`;

export const Description = styled.div`
  ${({ isListingsPage }) => `  
    font-size: 14px;
    max-height: 92px;
    overflow: auto;
    display: ${isListingsPage ? 'none' : 'block'};

    @media ${minBp('tabletLarge')} {
      display: block;
    }

    ul {
      margin: 0;
      padding: 0;
      padding-left: 16px;
    }

    li {
      padding: 3px 0;
    }
  `}
`;

export const Actions = styled.div`
  border-top: 1px solid #e0e0e0;
  padding: 10px 0;
  display: flex;
`;

export const Divider = styled.div`
  width: 1px;
  height: 43px;
  background-color: #e0e0e0;
`;

// Stop styled-components passing primary prop into Link
const _Link = ({ primary, ...props }) => <Link {...props} />; // eslint-disable-line

export const Action = styled.div`
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  flex: 1;
  appearance: none;
  color: black;
  font-size: 15px;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  text-decoration: none;

  ${({ primary, theme }) =>
    primary
      ? `
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    color: ${theme.colors.buttons.primary};
    font-weight: 500;
  `
      : ``}

  &:focus {
    background-color: #fafafa;
  }
`;
